export const LOADING_DATA = "LOADING_DATA";
export const CALLBACK_ERROR = "CALLBACK_ERROR";

//Action Creator
export const setLoading = (data) => {
    return { type: LOADING_DATA, data }
}

export const setCallbackError = (data) => {
    return { type: CALLBACK_ERROR, data }
}